import authTypes from "../types/auth";

function updateAoSI(payload) {
  return {
    type: authTypes.GET_AOSI_SUCCESS,
    payload,
  };
}

function apiError(payload) {
  return {
    type: authTypes.API_ERROR,
    payload,
  };
}

const auth = {
  apiError,
  updateAoSI,
};

export default auth;
